import React from "react";

const BarLoader = (): React.ReactElement => {
  return (
    <div
      data-testid="bar-loader"
      className="fixed top-0 left-0 w-full h-1 z-6000 bg-primary/20 overflow-hidden"
    >
      <div className="animate-bar-loader h-full w-full bg-primary" />
    </div>
  );
};

export default BarLoader;
